export default {
  data() {
    return {
      defaultDataLayer: {
        event: 'pageview',
        section: 'digital-learning',
        subsection: 'Home',
        subsection2: '',
        language: this.$i18n.locale,
        logged: false,
      },
    }
  },

  methods: {
    gtmInit() {
      this.$gtm.init('GTM-TT4GHQX')
      this.$gtm.push({ ...this.defaultDataLayer })
    },
  },

  created() {
    this.gtmInit()
  },
}
